<div class="table-responsive">
  <table class="tablest1">
    <thead>
      <tr>
        <th style="width: 55px" scope="col">#</th>
        <th scope="col" translate>lblWoNo</th>
        <th scope="col" translate>lblShortDescription</th>
        <th scope="col" translate>lblCustomerRequirement</th>
        <th scope="col" translate>lblApprovalComment</th>
        <th scope="col" class="text-right" translate>lblTotalHours</th>
        <th scope="col" class="text-right" translate>lblTotalPrice</th>
        <th scope="col" class="text-right" translate>lblCreatedDate</th>
        <th scope="col" class="text-right" translate>lblApprovalDate</th>
      </tr>
    </thead>

    <tbody>
      <ng-container
        *ngIf="
          soldHoursDetailsGridData?.length > 0;
          else load_NotFound_Template
        "
      >
        <ng-container
          *ngFor="let item of soldHoursDetailsGridData; let i = index"
        >
          <tr class="click" (click)="openAppointment(item.appointmentId)" onkeypress="void(0)">
            <td>{{ i + 1 }}</td>
            <td>
              <ngb-highlight [result]="item.ifsWorkOrderNumber">
              </ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="item.shortDescription"> </ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="item.customerRequirement">
              </ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="item.customerApprovalComment">
              </ngb-highlight>
            </td>
            <td class="text-right">
              {{ getDurationInHours(item.duration) | number : '1.2-2' }}
            </td>
            <td class="text-right">
              {{ item.totalPrice | number : '1.2-2' }} 
            </td>
            <td class="text-right">
                <ngb-highlight
                  [result]="item.createdDate | date : dateTimeFormat"
                >
                </ngb-highlight>
            </td>
            <td class="text-right">
                <ngb-highlight
                  [result]="item.approvalTimeStamp | date : dateTimeFormat"
                >
                </ngb-highlight>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-template #load_NotFound_Template>
        <tr>
          <td colspan="9" class="no-record" translate>lblNoRecordsFound</td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>
